import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import UnderNegotiation from '../../../container/templates/UnderNegotiationContainer';
import PendingNegotiation from '../../../container/templates/PendingNegotiationContainer';
import DoneNegotiation from '../../../container/templates/DoneNegotiationContainer';
import LatestSummary from '../../../container/templates/LatestSummaryContainer';
import SearchResult from '../../../container/templates/SearchResult';
import Auth from '../../../container/templates/AuthContainer';
import '@common/component/pages/app.css';
import NotFound from '@common/component/organisms/NotFound';
import Sorry from '@common/container/templates/SorryContainer';
import { SCREEN } from '@common/Common';
import Cookies from 'js-cookie';
import Visit from '../../../component/templates/Visit';
import SummaryPreview from '../../../component/templates/SummaryPreview';
import ProxyLogin from '../../../component/templates/ProxyLogin';
import LinkedDataResult from '../../templates/LinkedDataResult';
import CustomerList from '../../templates/CustomerList';

//実行環境
// const URL = process.env.REACT_APP_URL!;
class App extends Component<{}, any> {
  constructor(props: string) {
    super(props);
    this.state = {
      message: '',
    };
    this.selectRoute = this.selectRoute.bind(this);
  }

  selectRoute() {
    if (window.location.pathname === '/sorry') {
      return <Route path='/sorry' component={Sorry} />;
    }

    window.onunload = function () {
      Cookies.remove('sessionId');
      Cookies.remove('userInfo');
    };

    return (
      <Auth>
        <Switch>
          <Route exact path='/' component={LatestSummary} />
          <Route path={`${SCREEN.UNDER_NEGOTIATION.URL}/:type`} component={UnderNegotiation} />
          <Route path={`${SCREEN.PENDING_NEGOTIATION.URL}/:type`} component={PendingNegotiation} />
          <Route path={`${SCREEN.DONE_NEGOTIATION.URL}/:type`} component={DoneNegotiation} />
          <Route path={`${SCREEN.CUSTOMER_INFO_LIST.URL}`} component={CustomerList} />
          <Route path={`${SCREEN.NEGOTIATION_SEARCH_RESULT.URL}`} component={SearchResult} />
          <Route path={`${SCREEN.VISIT.URL}/summary`} component={Visit} />
          <Route path={`${SCREEN.VISIT.URL}/list`} component={Visit} />
          <Route path={`${SCREEN.SUMMARY_PREVIEW.URL}/:customerId/:scrollTargetType?/:id?`} component={SummaryPreview} />
          <Route path={`${SCREEN.PROXY_LOGIN.URL}`} component={ProxyLogin} />
          <Route path={`${SCREEN.LINKED_DATA_RESULT.URL}`} component={LinkedDataResult} />
          <Route path='/sorry' component={Sorry} />
          <Route component={NotFound} />
        </Switch>
      </Auth>
    );
  }

  render() {
    return (
      <Router>
        <this.selectRoute />
      </Router>
    );
  }
}

export default App;
